import React from 'react';
import {makeStyles} from "@mui/styles";
import {IntegrationItemProps} from "../../api/integrations/IntegrationsDTO";
import {IntegrationListItem} from "./IntegrationListItem";
import {IntegrationsSearch} from "./IntegrationsSearch";

const useStyles = makeStyles({
    root: {
        marginTop: 24
    }
}
);

interface Props {
    readonly data: IntegrationItemProps[]
    readonly onSearch: (value: string) => void
}



export function IntegrationListWrapper({data,onSearch}: Props) {
    const classes = useStyles();


    return (
        <>
            <IntegrationsSearch onSearch={onSearch} />
            <ul className={classes.root}>
                {data.map(item => {
                    return (
                        <IntegrationListItem key={item.id} data={item}/>
                    )
                })}
            </ul>
        </>
    );
}

